import { useParams, Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import { categories, hotArticles, latestArticles } from '@/mocks/articles';

export default function CategoryPage() {
  const { slug } = useParams<{ slug: string }>();
  const category = categories.find((c) => c.slug === slug);
  const name = category?.name || '分类';

  const allArticles = [...hotArticles, ...latestArticles];
  const filteredArticles = allArticles.filter((a) => a.categorySlug === slug);
  const articles = filteredArticles.length ? filteredArticles : allArticles;

  const categoryJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'CollectionPage',
    name: `${name} - 爆料吃瓜网`,
    description: `爆料吃瓜网${name}频道，实时追踪${name}相关的最新爆料和独家资讯，每日更新。共${category?.articleCount.toLocaleString() || articles.length}篇文章。`,
    url: `http://wjf5l.cn/category/${slug}`,
    isPartOf: {
      '@type': 'WebSite',
      name: '爆料吃瓜网',
      url: 'http://wjf5l.cn/',
    },
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://wjf5l.cn/',
      },
      {
        '@type': 'ListItem',
        position: 2,
        name: name,
      },
    ],
  };

  return (
    <>
      <JsonLd data={categoryJsonLd} />
      <JsonLd data={breadcrumbJsonLd} />
      <Navbar />
      <main className="pt-20 pb-16">
        <div className="px-4 md:px-6 lg:px-10">
          <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6 flex-wrap" aria-label="面包屑导航">
            <Link to="/" className="hover:text-accent-400 transition-colors">首页</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-foreground-300">{name}</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-heading font-black text-foreground-50 mb-2">
            {name}
          </h1>
          <p className="text-foreground-500 mb-8">
            共 {category?.articleCount.toLocaleString() || articles.length} 篇文章 · 每日更新独家爆料
          </p>

          <div className="flex flex-wrap gap-2 mb-10">
            {categories.map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`inline-flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 whitespace-nowrap ${
                  slug === cat.slug
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-200 text-foreground-400 border border-secondary-700/40 hover:border-secondary-500/60 hover:text-foreground-200'
                }`}
              >
                <i className={`${cat.icon} text-xs`}></i>
                {cat.name}
              </Link>
            ))}
          </div>

          {articles.length > 0 ? (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={`/article/${article.slug}`}
                  className="group block rounded-xl overflow-hidden border border-secondary-800/40 bg-background-200 hover:border-secondary-600/60 transition-all duration-300"
                >
                  <div className="aspect-[16/10] overflow-hidden">
                    <img
                      src={article.coverImage}
                      alt={article.title}
                      title={`爆料吃瓜 - ${article.title}`}
                      className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                  <div className="p-5">
                    <div className="flex items-center gap-3 text-xs text-foreground-500 mb-2">
                      <span>{article.author}</span>
                      <span className="w-1 h-1 rounded-full bg-foreground-600"></span>
                      <span>{article.publishDate}</span>
                    </div>
                    <h3 className="text-base font-bold text-foreground-50 group-hover:text-primary-400 transition-colors duration-200 line-clamp-2">
                      {article.title}
                    </h3>
                    <p className="mt-2 text-sm text-foreground-500 line-clamp-2">
                      {article.excerpt}
                    </p>
                    <div className="mt-3 flex flex-wrap gap-1.5">
                      {article.tags.slice(0, 2).map((tag) => (
                        <span
                          key={tag}
                          className="px-2 py-0.5 text-xs rounded-full bg-secondary-800/40 text-foreground-500"
                        >
                          #{tag}
                        </span>
                      ))}
                    </div>
                    <div className="mt-3 flex items-center justify-between text-xs text-foreground-600">
                      <span className="flex items-center gap-1">
                        <i className="ri-eye-line"></i>
                        {article.viewCount.toLocaleString()} 阅读
                      </span>
                      <span className="flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-accent-400">
                        阅读全文
                        <i className="ri-arrow-right-line"></i>
                      </span>
                    </div>
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <div className="text-center py-20">
              <i className="ri-inbox-line text-5xl text-foreground-500 block mb-4"></i>
              <p className="text-foreground-400 text-lg">该分类暂无文章</p>
              <Link
                to="/"
                className="mt-4 inline-flex items-center gap-2 text-accent-400 hover:text-accent-300 transition-colors"
              >
                <i className="ri-arrow-left-line"></i>
                返回首页
              </Link>
            </div>
          )}
        </div>
      </main>
      <Footer />
    </>
  );
}